import type { StyleRules, Theme } from '~/utils/withStyles';

const formStyles = (theme: Theme) => ({
  cancelButton: {},
  extraLarge: {
    height: theme.spacing(6.9),
    padding: `0px ${theme.spacing(2)}px 0px ${theme.spacing(1)}px !important`,
  },
  submitButton: {
    '&:disabled': {
      color: theme.palette.grey[800],
    },
    margin: '0 auto',
  },
  submitButtonSpinner: {
    marginRight: theme.spacing(1),
  },
  submitGroup: {
    '&:first-child': {
      marginTop: 0,
    },
    marginTop: theme.spacing(2),
    textAlign: 'center',
  },
} as const satisfies StyleRules);

export default formStyles;
